function shouldCloseOverlayOnKey(event, isOpen) {
  if (!isOpen || !event) return false;
  const key = event.key || event.code;
  return key === 'Escape' || key === 'Esc';
}

function closeOverlayOnEscape(event, isOpen, close) {
  if (!shouldCloseOverlayOnKey(event, isOpen)) return false;
  if (typeof close === 'function') close();
  return true;
}

module.exports = {
  shouldCloseOverlayOnKey,
  closeOverlayOnEscape,
};
